import { CenteredColumn } from 'src/components/DUP/molecules/WizardProofOfIncome/styles';
import { StyledText } from 'src/pages/DUPPage/styles';
import styled from 'styled-components/macro';

export const TileContainer = styled(CenteredColumn)`
  gap: 0.5rem;
  border-radius: 8px;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme }) => theme.redesignColor.gray[90]};
  background: #fff;
  width: 100%;
  padding: 1.5rem;
  align-items: start;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

export const HeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const Title = styled(StyledText)`
  text-transform: capitalize;
`;

export const Subtitle = styled(StyledText)`
  font-style: italic;
`;
